const SCALE = 1.5;

export const PDFJS_WORKER_SRC =
  'https://unpkg.com/pdfjs-dist@4.0.379/build/pdf.worker.mjs';
export const PDFJS_CMAP_URL = 'https://unpkg.com/pdfjs-dist@4.0.379/cmaps/';
export const PDFJS_STANDARD_FONT_DATA_URL =
  'https://unpkg.com/pdfjs-dist@4.0.379/standard_fonts/';

export const generatePdfThumbnails = async source => {
  const pdflib = window.pdfjsLib;
  pdflib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;

  const loadingTask = pdflib.getDocument({
    url: source,
    cMapUrl: PDFJS_CMAP_URL,
    cMapPacked: true,
    standardFontDataUrl: PDFJS_STANDARD_FONT_DATA_URL,
  });

  const pdf = await loadingTask.promise;
  const pdfPages = [];
  const pageCount = pdf._pdfInfo.numPages;

  for (let pageNumber = 0; pageNumber < pageCount; pageNumber++) {
    const page = await pdf.getPage(pageNumber + 1);
    const viewport = page.getViewport({ scale: SCALE });
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;

    pdfPages.push({
      page: pageNumber + 1,
      thumbnail: canvas.toDataURL(),
    });
  }

  return pdfPages;
};
